// Copyright (c) Mysten Labs, Inc. — DGC modifications CPC Chain contributors
// SPDX-License-Identifier: Apache-2.0

import { SuiClient, SuiHTTPTransport, getFullnodeUrl } from '@mysten/sui.js/client';

export enum Network {
	LOCAL = 'LOCAL',
	DEVNET = 'DEVNET',
	TESTNET = 'TESTNET',
	MAINNET = 'MAINNET',
}

const cpcLocalRpc =
	(typeof import.meta !== 'undefined' &&
		import.meta.env &&
		import.meta.env.VITE_CPC_RPC_URL) ||
	'https://rpc.dgclabs.cc';

export const NetworkConfigs: Record<Network, { url: string }> = {
	[Network.LOCAL]: { url: cpcLocalRpc },
	[Network.DEVNET]: { url: getFullnodeUrl('devnet') },
	[Network.TESTNET]: { url: getFullnodeUrl('testnet') },
	[Network.MAINNET]: { url: getFullnodeUrl('mainnet') },
};

const defaultClientMap: Map<Network | string, SuiClient> = new Map();

export const createSuiClient = (network: Network | string) => {
	const existingClient = defaultClientMap.get(network);
	if (existingClient) return existingClient;

	const networkUrl = network in Network ? NetworkConfigs[network as Network].url : network;

	const client = new SuiClient({
		transport: new SuiHTTPTransport({ url: networkUrl }),
	});
	defaultClientMap.set(network, client);
	return client;
};
